import { useState } from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { devLog } from '../utils/devLog';

export const DebounceAddressSelection = ({ value, handleClose }) => {
  const [address, setAddress] = useState(value);

  // constructor(props) {
  //   super(props);
  //   this.state = { address: '' };
  // }

  const handleChange = (theAddress) => {
    setAddress(theAddress);
  };

  const handleSelect = (theAddress) => {
    setAddress(theAddress);
    handleClose(theAddress);
    geocodeByAddress(theAddress)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => devLog('Success', latLng))
      .catch((error) => console.error('Error', error));
  };

  return (
    <PlacesAutocomplete
      value={address}
      onChange={handleChange}
      onSelect={handleSelect}
      onPlaceSelect={() => handleClose(address)}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <input
            {...getInputProps({
              placeholder: 'Search Places ...',
              className: 'location-search-input rs-input',
            })}
          />
          <div className="autocomplete-dropdown-container">
            {loading && <div>Loading...</div>}
            {suggestions.map((suggestion) => {
              const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
              // inline style for demonstration purpose
              const style = suggestion.active
                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                : { backgroundColor: '#ffffff', cursor: 'pointer' };
              return (
                <div
                  {...getSuggestionItemProps(suggestion, {
                    className,
                    style,
                  })}
                >
                  <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
};
